<script>
  import { analyticsStore, PreferenceState } from '$lib/analytics/store';
  import Link from './Link.svelte';
</script>

{#if $analyticsStore.shouldRequestConsent === PreferenceState.Yes}
  <div class="banner">
    <p>
      We use cookies to gather basic analytics on how visitors use our website.
      <Link to="/cookie-policy" rel="external">Learn More.</Link>
    </p>
    <div class="actions">
      <Link as="button" on:click={analyticsStore.acceptAnalytics}>Yum, cookies!</Link>
      <Link as="button" on:click={analyticsStore.declineAnalytics}>Decline</Link>
    </div>
  </div>
{/if}

<style lang="scss">
  @import 'src/scss/media';

  .banner {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: var(--twist-color-gray-100);
    padding: 24px 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: map-get($zIndex, cookie-banner);

    @include at('lg') {
      flex-direction: row;
      margin-bottom: var(--twist-core-spacing-0);
    }
  }

  .actions {
    display: flex;
    gap: var(--twist-core-spacing-5);
    align-self: flex-end;
  }

  p {
    color: var(--twist-color-gray-0);
    font-family: var(--font-family-primary);
    font-size: var(--twist-font-size-0);
    line-height: 160%;
    font-weight: var(--ifm-font-weight-light);
    margin: 0 0 var(--twist-core-spacing-5);

    @include at('lg') {
      margin: var(--twist-core-spacing-0);
    }
  }
</style>
